<template>
  <div style="width: 100%;">
    <p style="text-align: center; color: #FD5902; font-size: 14px;margin-bottom: 10px;">该微信暂未绑定，请验证账号</p>

    <div class="login_mn">
      <a-form-model ref="bindForm" :model="bindForm" :rules="rules">
        <a-form-model-item prop="mobile" >
          <div class="input-div" style="position: relative;">
            <img src="~@/assets/images/login/ic_mobile.png" >
            <a-input style="position: absolute;left: 35px;width: 293px;" v-model="bindForm.mobile"  placeholder="请输入手机号码"/>
          </div>
        </a-form-model-item>

        <a-form-model-item prop="imgCode" >
          <div class="input-div" style="position: relative;">
            <img src="~@/assets/images/login/ic_img_code.png" >
            <a-input style="position: absolute;left: 35px;width: 180px;"  v-model="bindForm.imgCode"  placeholder="请输入验证码" @focus='clearTips'/>
            <img :src="imgCode" @click="getImgCode" class="img-code"/>
          </div>
        </a-form-model-item>

        <a-form-model-item prop="smsCode" >
          <div class="input-div" style="position: relative;">
            <img src="~@/assets/images/login/ic_sms_code.png" >
            <a-input style="position: absolute;left: 35px;width: 180px;"   v-model="bindForm.smsCode"  placeholder="请输入动态验证码"/>
            <span class="btn_sms_code" @click="getSmsCode">{{this.enableGetSmsCode ? '获取短信验证码' : `${this.smsCodeTime}秒后获取`}}</span>
          </div>
          <template #help><span class="tips">{{help}}</span></template>
        </a-form-model-item>
        <a-form-item class="login_btn">
          <a-button size="large" block type="primary" @click="bindWx">绑定</a-button>
        </a-form-item>
      </a-form-model>

    </div>

  </div>
</template>

<script>
  export default {
    name: 'BindWx',
    created() {
      this.getImgCode();
    },
    data () {
      return {
        rules: {
          imgCode: [
            { required: true, message: '请输入验证码', trigger: ['blur', 'change'] }
          ],
          mobile: [
            { required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },
            { validator: this.$validate.mobile, trigger: ['blur'] }
          ],
          smsCode: [
            { required: true, message: '请输入动态验证码', trigger: ['blur', 'change'] }
          ]
        },
        imgCode:'',
        imgKey:'',
        bindForm:{
          mobile:'',
          imgCode:'',
          smsCode:''
        },
        enableGetSmsCode: true,
        smsCodeTime: 60,
        help:''
      }
    },
    methods: {
      getImgCode(){
        var _this = this;

        _this.$util.api('/code',{},function(res){
          if(res.code == 10000){
            _this.imgCode = res.data.img;
            _this.imgKey = res.data.key;
          }
        });
      },
      bindWx(){
        this.$refs.bindForm.validate(status => {
          if (!status) return
          this.$emit('submit', this.bindForm)
        })
      },
      clearTips(){
        this.help='';
      },
      getSmsCode () {
        if (!this.enableGetSmsCode) return
        let validateStatus = true
        this.$refs.bindForm.validateField(['mobile', 'imgCode'], err => {
          if (err) validateStatus = false
        })

        if (validateStatus) {
          //获取手机短信
          var _this = this;
          let params = {
            mobile: _this.bindForm.mobile,
            code: _this.bindForm.imgCode + ',' + _this.imgKey,
            action: 'login'
          };
          _this.$util.api('/sms',params,function(res){

            if(res.code == 10000 && _this.bindForm.mobile==res.data){
              _this.enableGetSmsCode = false
              let countDown = setInterval(() => {
                --_this.smsCodeTime
                if (_this.smsCodeTime === 0) {
                  clearInterval(countDown)
                  _this.enableGetSmsCode = true
                  _this.smsCodeTime = 60
                }
              }, 1000)
            }else{
              //报错
              _this.help=res.msg;
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
  .login_mn {width:100%; float:left; margin-bottom:20px;}
  .login_mn .ant-form-item .input-div{width:330px; height:40px; border:1px solid #d8d8d8;}
  .login_mn .ant-form-item .input-div input{width:295px;text-indent: 10px;border: none;float: left;height: 38px;line-height: 38px;}
  .login_mn .ant-form-item img{width:35px; height:38px; border:none;margin-left: 35px;}
  .login_mn .ant-form-item img.img-code{ width: 115px;  height: 39px;  float: right;}
  .login_mn span.btn_sms_code{width: 115px;  height:38px; float:right; line-height:38px; text-align:center; background:#fff4e9; font-size:14px; color:#fd5902; cursor:pointer;}

  .login_but{width:300px; height:50px; line-height:50px; margin:0 auto; background:#fd5902; color:#ffffff; font-size:18px; text-align:center; cursor:pointer;}
  .login_mn .ant-form-item-children img{
    margin-left: 0;
  }
  .tips{
    color:#f5222d;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/login/BindWx.vue